import * as firebase from "firebase/app";
import "firebase/firestore"

import * as firebaseui from "firebaseui";

const config = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  projectId: process.env.VUE_APP_PROJECTID
};
if (!firebase.apps.length) {
    firebase.initializeApp(config)
}

let _ui = firebaseui.auth.AuthUI.getInstance();
if (!_ui) {
  _ui = new firebaseui.auth.AuthUI(firebase.auth());
}

export const ui = _ui
export default firebase
